import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from "moment";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from "@material-ui/core/Button/Button";
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import {MOBILE_TABLE_VIEW_AMOUNT} from "../../helpers/constants";
import TablePagination from "@material-ui/core/TablePagination";
import {scrollToElement} from "../../helpers/functions";
import SortPillarsForm from './sortPillarsForm';
import _ from "lodash";

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  summaryContent: {
    flexWrap: 'wrap'
  }
});

class PillarsListMobileView extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      expanded: null,
    };

    this.pillarsMobileListRef = React.createRef();

  }

  componentDidMount(){
    this.props._changeLocalState({
      key: 'rowsPerPage',
      value: MOBILE_TABLE_VIEW_AMOUNT
    })
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    const { classes, pillars, handleChangePage, handleChangeRowsPerPage, page, rowsPerPage } = this.props;
    const { expanded } = this.state;

    return (
      <div className={classes.root} ref={this.pillarsMobileListRef}>
        <Typography variant="h6" id="tableTitle" className={'mb-3'}>
          Pillars
        </Typography>
        <SortPillarsForm
          {...this.props}
          initialValues={{sortBy: 'createdDate', sortOrder: 'desc'}}
        />
        {
          _.orderBy(pillars, item => item[this.props.mobileViewSortBy], this.props.mobileViewSortOrder)
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map(pillar => {
            return (
              <ExpansionPanel
                key={pillar.id}
                expanded={expanded === pillar.id}
                onChange={this.handleChange(pillar.id)}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} classes={{content: classes.summaryContent}}>
                  <Typography className={classes.heading}>{pillar.name}</Typography>
                  <Typography className={classes.secondaryHeading}>
                    {moment(pillar.createdDate).format('DD/MM/YYYY HH:mm:ss')}
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Table >
                    <TableBody>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Id'}</TableCell>
                        <TableCell>{pillar.id}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Εξάμηνη βαρύτητα'}</TableCell>
                        <TableCell>{pillar.weightOld}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Βαρύτητα νέων καταστημάτων'}</TableCell>
                        <TableCell>{pillar.weightNew}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Βαρύτητα υφιστάμενων καταστημάτων'}</TableCell>
                        <TableCell>{pillar.weightNewComing}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Created Date'}</TableCell>
                        <TableCell>{moment(pillar.createdDate).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </ExpansionPanelDetails>
                <ExpansionPanelActions>
                  <Button
                    size="small"
                    onClick={() => this.props._openDeleteModal(pillar.id)}
                  >
                    {'Delete'}
                  </Button>
                  <Button
                    size="small"
                    color="primary"
                    onClick={() => this.props.history.push('/pillar/' + pillar.id)}
                  >
                    {'Edit'}
                  </Button>
                </ExpansionPanelActions>
              </ExpansionPanel>
            )
          })
        }
        <TablePagination
          classes={
            {
              root: classes.pager,
              toolbar: classes.pagerToolbar
            }
          }
          rowsPerPageOptions={[]}
          labelRowsPerPage={''}
          component="div"
          count={pillars.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onChangePage={(evt, page) => {
            scrollToElement(this.pillarsMobileListRef.current);
            handleChangePage(evt, page);
          }}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

PillarsListMobileView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PillarsListMobileView);



// WEBPACK FOOTER //
// ./src/components/pillars/pillarsListMobileView.js